import { css, keyframes } from '@emotion/react';

// <Reveal>의 keyframes 프로퍼티로 넘겨준다.
export const floating = keyframes`
    0% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-15px);
    }

    100% {
        transform: translateY(0px);
    }
`;

/*
    <Reveal>의 css 프로퍼티로 넘겨준다.
    keyframes로 넘겨주는 것 보다 조금 더 자유
*/

export const floatingCss = css`
  animation: ${floating} 2s ease infinite;
`;

export const scale = keyframes`
    0% {
        transform: scale(1)
    }
    50% {
        transform: scale(1.05)
    }
    100% {
        transform: scale(1)
    }
`;

export const scaleCss = css`
  animation: ${scale} 1s ease infinite;
`;

export const wiggleWiggle = keyframes`
    20%,
  100% {
    transform: translate(0, 20px);
  }

  0% {
    transform: translate(0, 0px);
  }
  10% {
    transform: translate(0, 20px);
  }

`;
export const jump = keyframes`
  33% {
    text-shadow: 0 60px #f37121, 0 150px #f2aaaa;
  }
  50% {
    transform: translate(0, 0) rotate(-4deg);
    text-shadow: 0 0px #8fc0a9, 0 0px #84a9ac;
  }
  66.67% {
    text-shadow: 0 -60px #d54062, 0 -150px #8fc0a9;
  }
`;

export const rotate3D = keyframes`
  0% { transform: rotate3d(0,1,0,0deg); }
  50% { transform: rotate3d(0,1,0,90deg); }
  50.0001% { transform: rotate3d(0,1,0,270deg); }
  100% { transform: rotate3d(0,1,0,360deg); }
`;

export const fadeIn = keyframes`
  0% { opacity:0;  }
  66% { opacity:0; }
  100% { opacity:1;  }
`;

// matrix (scaleX, skewX, skewY, scaleY, translateX, translateY)
export const bounce = keyframes`

100% {
  transform: matrix(1, 0, 0, 1, 0, -10);
  }
`;

export const moveIt = keyframes`
  0% { 
     /* transform:  scale3d(1,0.96,1); */
    transform: scale3d(1,0.96,1);
  }
  20% {
     /* transform:  scale3d(1,1.1,1);  */
     transform:  scale3d(1,1.4,1); 
  }
  40% {
     /* transform:  scale3d(1,0.98,1);  */
     transform:  scale3d(1,0.98,1); 
  }
  60% {
     /* transform:  scale3d(1,1.05,1);  */
     transform:  scale3d(1,1.1,1); 
  }
  80% {
     /* transform:  scale3d(1,1.01,1);  */
     transform:  scale3d(1,1.01,1); 
  }
  100% {
  visibility: visible;
     transform: scale3d(1,1,1); 
  }
  `;
export const moveItBack = keyframes`
  0% { transform: translateY(60px); }
  100% {
     transform: translateY(0) scale3d(0.96,0.96,1); 
  }
`;

export const changeBg = {
  yellow: keyframes`
    33% {
      background-color: rgb(247, 174, 220);
    }

    66% {
      background-color: var(--bg-color);
    }

    100% {
      background-color: rgb(248, 227, 56);
    }
    `,
  pink: keyframes`
    33% {
      background-color: var(--bg-color);
    }

    66% {
      background-color: rgb(248, 227, 56);
    }

    100% {
      background-color: rgb(247, 174, 220);
    }
    `,
  blue: keyframes`
    33% {
      background-color: rgb(248, 227, 56);
    }

    66% {
      background-color: rgb(247, 174, 220);
    }

    100% {
      background-color: var(--bg-color);
    }
    `,
};

/**
 *
 * @param delay 한 엘리먼트당 애니메이션 딜레이 (ms)
 * @param childCount child로 가지고 있는 엘리먼트 갯수
 *
 */
export const setAnimationDelayLoop = (delay: number, childCount: number) => {
  const styles = {};
  for (let $i = 1; $i <= childCount; $i++) {
    styles['&:nth-of-type(' + $i + ')'] = {
      animationDelay: $i * delay + 'ms',
    };
  }
  return styles;
};
